module.exports = __webpack_public_path__ + "img/cf74fa052c5aa129bcf958ca333de148.927fbab5.jpg";